const CHAT_TITLE_CACHE_KEY = 'chatTitleCache';
const CHAT_TITLE_CACHE_LIMIT = 100;

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn('Unable to parse chat title cache', error);
    return null;
  }
};

const readCache = () => {
  if (typeof window === 'undefined') return { titles: {} };
  const raw = localStorage.getItem(CHAT_TITLE_CACHE_KEY);
  if (!raw) return { titles: {} };
  const parsed = safeParse(raw);
  if (!parsed || typeof parsed !== 'object') {
    return { titles: {} };
  }
  return {
    titles: parsed.titles || {}
  };
};

const writeCache = (cache) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(CHAT_TITLE_CACHE_KEY, JSON.stringify(cache));
  } catch (error) {
    console.warn('Unable to persist chat title cache', error);
  }
};

export const cacheChatTitle = (chatId, title) => {
  if (!chatId || !title || typeof window === 'undefined') return;
  const cache = readCache();
  cache.titles = cache.titles || {};
  cache.titles[chatId] = { title, updatedAt: Date.now() };

  const entries = Object.entries(cache.titles);
  if (entries.length > CHAT_TITLE_CACHE_LIMIT) {
    entries
      .sort((a, b) => a[1].updatedAt - b[1].updatedAt)
      .slice(0, entries.length - CHAT_TITLE_CACHE_LIMIT)
      .forEach(([oldId]) => delete cache.titles[oldId]);
  }

  writeCache(cache);
};

export const getCachedChatTitle = (chatId) => {
  if (!chatId || typeof window === 'undefined') return null;
  const cache = readCache();
  return cache.titles?.[chatId]?.title || null;
};

export const getLastChatTitle = () => {
  if (typeof window === 'undefined') return null;
  const lastChatId = localStorage.getItem('lastChatId');
  if (!lastChatId) return null;
  return getCachedChatTitle(lastChatId);
};


